<template>
  <el-dialog
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    class="customDialogForm"
    :title="title"
  >
    <el-form
      v-if="!showKey && !accessKey"
      ref="userform"
      :rules="rules"
      :model="data"
    >
      <el-form-item prop="note" label="用途" :label-width="formLabelWidth">
        <el-input v-model="data.note" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        prop="expiredTime"
        label="过期时间"
        :label-width="formLabelWidth"
      >
        <el-date-picker
          v-model="data.expiredTime"
          :picker-options="expireTimeOption"
          type="date"
          :editable="false"
          placeholder="选择过期日期，留空则不过期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item prop="actions" label="授权" :label-width="formLabelWidth">
        <el-select
          filterable
          multiple
          v-model="data.actions"
          placeholder="授予权限"
        >
          <el-option
            v-for="item in openMarket ? marketActions : actions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div v-if="showKey || accessKey">
      <el-alert
        title="请复制并保存AccessKey，其只显示一次"
        type="warning"
        show-icon
      ></el-alert>
      <div style="padding: 16px">
        {{ data.accessKey || accessKey.accessKey }}
        <el-button
          size="mini"
          v-clipboard:copy="data.accessKey || accessKey.accessKey"
          v-clipboard:success="onCopy"
          >复制</el-button
        >
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { addAccessKeyApi } from '@/api/enterpriseManage';
import { errorHandle } from '@/utils/error';
export default {
  name: 'AddUserToRole',
  props: {
    eid: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function,
    accessKey: Object,
    openMarket: Boolean
  },
  data() {
    return {
      data: {
        note: '用于Rainbond平台从本市场安装应用',
        actions: ['ReadInstall']
      },
      rules: {
        note: [{ required: true, message: '用途必填', trigger: 'blur' }]
      },
      app: {},
      actions: [
        {
          label: '只读权限',
          value: 'OnlyRead'
        },
        {
          label: '安装应用',
          value: 'ReadInstall'
        }
      ],
      marketActions: [
        {
          label: '只读权限',
          value: 'OnlyRead'
        },
        {
          label: '安装应用',
          value: 'ReadInstall'
        },
        {
          label: '推送应用&版本',
          value: 'Write'
        }
      ],
      title: this.accessKey ? '更新AccessKey' : '添加AccessKey',
      formLabelWidth: '80px',
      Loading: false,
      showKey: false,
      expireTimeOption: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      }
    };
  },
  created() {},
  methods: {
    onCopy() {
      this.$message.success('复制成功');
    },
    submit() {
      if (this.showKey || this.accessKey) {
        this.onSuccess && this.onSuccess();
        this.close();
        return;
      }
      this.$refs.userform.validate((valid) => {
        if (valid) {
          this.Loading = true;
          this.data.eid = this.eid;
          this.data.userID = this.$store.state.user.userInfo.userID;
          if (this.data.expiredTime) {
            this.data.expiredTime =
              new Date(this.data.expiredTime) - new Date();
            if (this.data.expiredTime <= 0) {
              this.$message.warning('过期时间必须大于当前时间');
              return;
            }
          }
          addAccessKeyApi(this.data)
            .then((res) => {
              this.Loading = false;
              this.data.accessKey = res.accessKey;
              this.showKey = true;
              this.$refs.userform.resetFields();
            })
            .catch((err) => {
              this.Loading = false;
              errorHandle(err);
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      if (this.$refs.userform) {
        this.$refs.userform.resetFields();
      }
      this.showKey = false;

      this.onClose && this.onClose();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/information/accesskey/components/add.vue